import { useMemo } from 'react';

import { useGetExternalLoyaltyManualOfferUpcsQuery } from '@occc/graphql';

export const useTobaccoApiOfferUpcs = (offerUuid: string | undefined, skip: boolean) => {
  const { data, loading, error } = useGetExternalLoyaltyManualOfferUpcsQuery({
    variables: { manualOfferUuid: offerUuid ?? '' },
    skip: skip || !offerUuid,
    fetchPolicy: 'no-cache',
  });

  const parRetailUpcs = useMemo(
    () => data?.externalLoyaltyManualOfferUpcs.presentOnActivateUpcs.map((item) => item.upc) ?? [],
    [data],
  );

  const apiUpcs = useMemo(
    () => data?.externalLoyaltyManualOfferUpcs.externalLoyaltyUpcs.map((item) => item.upc) ?? [],
    [data],
  );

  return { parRetailUpcs, apiUpcs, loading, error };
};
